function notInitialized() {
  throw new Error('System notification generator is not initialized');
}

export default {
  newNotification: notInitialized,
  canGenerateNotifications: notInitialized,
  closeNotification: notInitialized,
};



// WEBPACK FOOTER //
// ./src/scripts/domain/contracts/system_notification_generator.js